import React from 'react';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { useAuth } from 'context';
import { Navigate, Route, Routes } from 'react-router-dom';
import SharedRoutes from './SharedRoutes';
import PrivateRoute from './PrivateRoute';
import PublicRoutes from './PublicRoutes';
import PublicRoute from './PublicRoute';
import PrivateRoutes from 'app/components/routes/PrivateRoutes';

export default function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        index
        element={
          isAuthenticated ? (
            <Navigate to="/equipment" />
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route element={<PublicRoute />}>{PublicRoutes()}</Route>
      <Route element={<PrivateRoute />}>{PrivateRoutes()}</Route>
      {SharedRoutes()}

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
